module.exports = __webpack_public_path__ + "static/media/PANTALLA-MOVIL1.3cecb6c3.png";